import { render, staticRenderFns } from "./OrderScreenItem.vue?vue&type=template&id=7205b4de&scoped=true&"
import script from "./OrderScreenItem.vue?vue&type=script&lang=js&"
export * from "./OrderScreenItem.vue?vue&type=script&lang=js&"
import style0 from "./OrderScreenItem.vue?vue&type=style&index=0&id=7205b4de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7205b4de",
  null
  
)

export default component.exports